import { RequestPushNotificationDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../../../shared/scripts/ui_platform/mountDialogUIReactComponent.tsx';
import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { UIMDeviceHandler } from '../ui_html/UIMDeviceHandler.ts';
import { PushNotificationPopupIntentEnum, USER_ACTION_ENUM } from '../notifications/UIMRequestPushNotificationController.ts';
const renderRequestPushNotificationDialog = mountDialogUIReactComponent(RequestPushNotificationDialog);
export function showRequestPushNotificationDialog(intent) {
    const variant = intent == PushNotificationPopupIntentEnum.OnLoadHomePage ? 'homePage' : 'friendRequest';
    const onConfirm = ()=>{
        UIMDeviceHandler.requestNotificationPermission();
        sendPushNotificationAnalyticEvent(intent, USER_ACTION_ENUM.USER_ACCEPTED_PUSH_NOTIFICATION);
        StorageWrapper.setPushNotificationRequestStatus(true);
    };
    const onDecline = ()=>sendPushNotificationAnalyticEvent(intent, USER_ACTION_ENUM.USER_REJECTED_PUSH_NOTIFICATION);
    renderRequestPushNotificationDialog({
        variant: variant,
        onConfirm: onConfirm,
        onDecline: onDecline
    });
}
function sendPushNotificationAnalyticEvent(intent, userAction) {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.ABTestClickAnalytics,
        category: AnalyticEventCategory.ABTestPushNotificationsPopup,
        floatValue: userAction,
        stringValue: intent
    });
}
